import React, {useEffect} from "react";
import FormInput from "../components/form-input";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import BlockButton from "../components/block-button";
import {useNavigate} from "react-router-dom";
import keycloak from "../utils/keycloak";

type FormData = {
  carrierPostData: string;
  eid: string;
  iccid: string;
  displayName: string;
  deviceImei: string;
  deviceMeid: string;
  deviceType: string;
  primaryDeviceIccid: string;
};

const Workaround = () => {
  const { register, watch } = useForm<FormData>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navigateNextPage = () => {
    if(watchedValues.displayName === 'change-env') {
      keycloak.logout();
    }
    else {
      localStorage.setItem("primaryIccid", watchedValues.primaryDeviceIccid);
      localStorage.setItem('watchInfo', JSON.stringify(watchedValues));
      navigate("/manage-account");
    }
  };

  useEffect(() => {
    const primaryDeviceIccid = localStorage.getItem('primaryDeviceIccid');
    if(primaryDeviceIccid) {
      navigate("/manage-account");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const watchedValues = watch();

  return (
    <div className="layout-default">
      <div className="form-container">
        <FormInput
          data-testid="postData"
          {...register("carrierPostData")}
          formText={t("CARRIER POST DATA")}
        />
        <FormInput
          data-testid="eid"
          {...register("eid")}
          formText={t("EID")}
        />
        <FormInput
          data-testid="iccid"
          {...register("iccid")}
          formText={t("ICCID")}
        />
        <FormInput
          data-testid="displayName"
          {...register("displayName")}
          formText={t("DISPLAY NAME")}
        />
        <FormInput
          data-testid="deviceImei"
          {...register("deviceImei")}
          formText={t("DEVICE IMEI")}
        />
        <FormInput
          data-testid="deviceMeid"
          {...register("deviceMeid")}
          formText={t("DEVICE MEID")}
        />
        <FormInput
          data-testid="deviceType"
          {...register("deviceType")}
          formText={t("DEVICE TYPE")}
        />
        <FormInput
          data-testid="primaryDeviceIccid"
          {...register("primaryDeviceIccid")}
          formText={t("PRIMARY DEVICE ICCID")}
        />
      </div>

      <BlockButton dataTestId='continue-button' onClick={navigateNextPage} text={t("Continue")} />
    </div>
  );
};

export default Workaround;
